module.exports = __webpack_public_path__ + "static/Moderat-Light-9cf0fbd7c476f6f54d17fb30a8f87adb.woff";